import { WarningIcon } from 'src/modules/common/icons/WarningIcon.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { RegionsEnum } from 'src/generated/operations.ts';

export const VstWarning = ({ label, region }: { label : string; region: RegionsEnum }) => {
    if (/.*VST$/i.test(label) && region === RegionsEnum.Am) {
        return (
            <div className="vss-actuator-vst-warning">
                <div className="vss-actuator-vst-warning__icon">
                    <WarningIcon/>
                </div>

                <div className="vss-actuator-vst-warning__content">
                    <div className="vss-actuator-vst-warning__title">
                        <I18n messageId={MESSAGES.ActuatorAccessoriesVstWarningTitle}/>
                    </div>

                    <div className="vss-actuator-vst-warning__body">
                        <I18n messageId={MESSAGES.ActuatorAccessoriesVstWarningBody} params={{ label }}/>
                    </div>
                </div>
            </div>
        );
    }
    return '';
};
